export const MissingFieldMessages = Object.freeze({
	oldPassword: 'Current password is required.',
	newPassword: 'New password is required.',
	confirmNewPassword: 'You must confirm your new password.',
});
